import styled from 'styled-components';
import theme from '../../theme';

export const OutilsContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; Removed to allow left alignment */
  /* padding: 0 20px 120px 20px; Removed horizontal padding */
  padding-bottom: 120px; /* Keep only bottom padding */
  box-sizing: border-box; /* Ensure padding is included in width considerations */
  width: 100%;

  @media (min-width: 801px) { /* Corresponds to desktop view */
    width: calc(100% - 280px); /* Full width minus SideMenu */
    margin-left: 280px; /* Offset from the left to be next to SideMenu */
  }
`;

export const Header = styled.div`
  background: ${theme.colors.orange_fonce};
  width: 100%; /* Use 100% for responsiveness */
  min-height: 213px; /* Use min-height instead of fixed height */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Pushes button to bottom */
  padding: 20px;
  box-sizing: border-box;
  position: relative; /* For positioning the icon */
  /* margin: 0 -20px 0 -20px; /* Removed negative margin */
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* Align items to the top */
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;


export const TipsBadge = styled.div`
  width: 64px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.orange_fonce};
  font-family: 'Gabarito', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 10px; /* Add some space below */
`;

export const Description = styled.p`
  color: #FFF;
  font-family: 'Gabarito', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* width: 226px; Removed fixed width */
  max-width: 250px; /* Added max-width for better text wrapping */
  margin: 0; /* Remove default margin */
`;

export const HeaderIcon = styled.img`
  width: 60px; /* Adjust size as needed */
  height: auto;
  align-self: center; /* Vertically center relative to HeaderTop */
`;

export const ProposeButton = styled.button`
  border-radius: 15px;
  background: #FFF;
  box-shadow: ${props => props.active ? 'none' : '0px 3px 0px 0px #FFC598'};
  transform: ${props => props.active ? 'translateY(3px)' : 'translateY(0)'};
  /* width: 100%; Removed full width */
  width: 100%; /* Fill padded header area */
  height: 55px;
  flex-shrink: 0;
  color: ${theme.colors.orange_fonce};
  font-family: 'Gabarito', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: none;
  cursor: pointer;
  /* margin-left: auto; /* Center button */
  /* margin-right: auto; /* Center button */
  /* display: block; /* Ensure margin auto works */
  /* margin-top: 20px; Removed margin-top, rely on flex justify-content */
  transition: all 0.15s ease; /* Add transition */
`;

export const Title = styled.h2`
  color: #4C4C4C;
  font-family: 'Gabarito', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 30px;
  margin-bottom: 20px;
  align-self: flex-start; /* Align title to the left */
  /* padding-left: 20px; Removed padding, parent container handles it */
  /* width: 100%; Ensure title spans width */
  padding: 0 20px; /* Add horizontal padding */
  box-sizing: border-box; /* Include padding in width */
  width: 100%; /* Ensure it spans the container */
`;

export const ToolButton = styled.button`
  border-radius: 15px;
  border: 1px solid ${theme.colors.gris_clair_default};
  background: #FFF;
  box-shadow: ${props => props.active ? 'none' : `0px 2px 0px 0px ${theme.colors.gris_clair_default}`};
  transform: ${props => props.active ? 'translateY(3px)' : 'translateY(0)'};

  /* width: 100%; Make button take full width within parent padding */
  width: calc(100% - 40px); /* Calculate width based on margins */
  /* max-width: 320px; /* Add max-width to match ProposeButton */
  /* margin-left: auto; /* Center if container allows */
  /* margin-right: auto; /* Center if container allows */
  margin: 0 20px 15px 20px; /* Set horizontal margins for spacing, keep bottom */
  height: 77px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  /* padding: 0 20px; /* Padding inside the button */
  padding: 0 15px; // Add slightly less internal padding for content
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.15s ease; /* Add transition */
  box-sizing: border-box; /* Include padding in width calculation */
`;

export const ToolIcon = styled.img`
  width: 35px; /* Adjust icon size */
  height: 35px;
  margin-right: 15px;
`;

export const ToolText = styled.span`
  color: #4C4C4C; /* Use a more readable color than #BCBBBB */
  font-family: 'Gabarito', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;